import "./index.scss";
import React from "react";
const SelectBox = (props) => {
  const {
    label = "",
    optionValues = [],
    name = "",
    value = "",
    onChange
  } = props.data;

  return (
    <div className="selectbox-wraper">
      <label>{label}</label>
      <div className="select-wraper">
        {value !== "0.00" &&
        value !== 0 &&
        value !== "Select (yyyy)" &&
        value !== "Select pupillari distance" &&
        value !== "LEFT" &&
        value !== "RIGHT" &&
        value !== "" ? (
          <div className="check"></div>
        ) : null}
        <select name={name} value={value} onChange={onChange}>
          {/* {placeholder == "DOB" && (
            <option value="DOB" disabled>
              Select (yyyy)
            </option>
          )}
          {placeholder == "PD" && (
            <option value="PD" disabled>
              Select pupillari distance
            </option>
          )} */}
          <option value={value} disabled>
            {value}
          </option>
          {optionValues.map((val) => (
            <option key={val} value={val}>
              {val}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
export default SelectBox;
